const urlParamRegexp = /{(\w+)}/g;

export class UrlBuilder {

  constructor(baseUrlTemplate) {
    this.baseUrlTemplate = baseUrlTemplate;
    this.params = {};
    this.urlParams = {};
  }

  withUrlParam(name, value) {
    this.urlParams[name] = value;
    return this;
  }

  withParam(name, value) {
    this.params[name] = value;
    return this;
  }

  withOptionalParam(name, value) {
    if (value) {
      this.params[name] = `${value}`;
    }
    return this;
  }

  build() {
    let url = this.baseUrlTemplate;

    url = url.replace(urlParamRegexp, (paramNameInBraces, paramName) => {
      const paramValue = this.urlParams[paramName];
      if (paramValue) {
        return encodeURIComponent(paramValue);
      } else {
        return paramNameInBraces;
      }
    });

    const entries = Object.entries(this.params);

    if (entries.length > 0) {
      url += '?';
      url += entries.map(
        ([key, value]) => `${key}=${encodeURIComponent(value)}`
      ).join('&');
    }

    return url;
  }

}
